<template>
    <section
        class="section"
        :data-width="sectionWidth"
    >
        <div class="section__container">
            <div
                class="section__header"
            >
                <slot name="header">
                    <h2
                        v-if="!!$slots.title"
                        class="section__title"
                    >
                        <slot name="title" />
                    </h2>
                </slot>
            </div>

            <div
                v-if="!!$slots.default"
                class="section__body"
            >
                <slot />
            </div>
        </div>
    </section>
</template>

<script setup>
defineProps({
    sectionWidth: {
        type: String,
        default: 'page',
        validator(value) {
            return ['page', 'content', 'bleed'].includes(value);
        }
    }
});
</script>

<style lang="less" src="./BaseSection.less" />
